import { Flex, Space, Table,App, Divider} from 'antd'
import React, { useEffect, useState } from 'react'
import ParamAdd from './ParamAdd'
import { useQingqiucanshuDelMutation, useQingqiucanshuListQuery } from '../../store/BnsKeJiApi';
import ModalDel from '../../cpn/ModalDel';
import ParamEdit from './ParamEdit';

function ParamList(props) {
    const {message} = App.useApp()
    const [list, setList] = useState();   
    const { data, isSuccess } = useQingqiucanshuListQuery({
        qqcs_et_id:props.et_id
    }, {
        refetchOnMountOrArgChange: 1,
    });
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const newArr = data.Result.map(item => {
                    const { qqcs_id: key, qqcs_name, qqcs_ctime, qqcs_require,qqcs_uname, qqcs_content, qqcs_type, qqcs_dept_name, qqcs_type_id,qqcs_uid} = item;
                    return item = { key, qqcs_name, qqcs_ctime,qqcs_require, qqcs_uname, qqcs_content, qqcs_type, qqcs_dept_name, qqcs_type_id,qqcs_uid }
                })
                const sortArr = newArr.sort((a, b) => {
                    let aTimeString = a.qqcs_ctime;
                    let bTimeString = b.qqcs_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;
                })
                setList(sortArr)
            } else {
                setList('')
            }
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'qqcs_name',
            title: '名称',
            dataIndex:'qqcs_name'
            
        },
        {
            key: 'qqcs_type',
            title: '类型',
            dataIndex: 'qqcs_type',
            
        },
        {
            key: 'qqcs_require',
            title: '',
            dataIndex: 'qqcs_require',            
        },
        {
            key: 'qqcs_content',
            title: '说明',
            dataIndex: 'qqcs_content',

        },
        {
            key: 'num',
            title: '编号',
            dataIndex: 'key',
        },
        {
            key: 'time',
            title: '',
            render: (_, record) => {
                return <>{record.qqcs_ctime + record.qqcs_uname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <ParamEdit
                            et_id={props.et_id}
                            et_name={props.et_name}
                            eu_id={props.eu_id}
                            eu_name={props.eu_name}
                            qqcs_id={record.key}
                            qqcs_uid={record.qqcs_uid}
                        />
                        <ModalDel onOk={() => {
                            del({ qqcs_id: record.key }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！' + res.data.Message)
                                }
                            })
                        }} />                       
                    </Space>
                </>
            }
        },
    ]
    const [del] = useQingqiucanshuDelMutation()
    return (
        <>
            <Divider>请求参数</Divider>
            <Flex justify='space-between'>
                <ParamAdd 
                    et_id={props.et_id}
                    et_name={props.et_name}
                    eu_id={props.eu_id}
                    eu_name={props.eu_name}
                />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={{
                    position: ['none','none'],                   
                }}
                style={{ marginTop: '20px' }}
            />
        </>
    )
}

export default ParamList